import { createAsyncAction } from 'typesafe-actions';
import { FhqInvitation } from '@rootCommon/types/fhq';
import { IdType } from '@rootCommon/types/common';

export const fetchFhqInvitationSettings = createAsyncAction(
  'FETCH_FHQ_INVITATION_SETTINGS_REQUEST',
  'FETCH_FHQ_INVITATION_SETTINGS_SUCCESS',
  'FETCH_FHQ_INVITATION_SETTINGS_FAILURE',
)
<IdType[], FhqInvitation[], Error>();

export const updateFhqInvitationSettings = createAsyncAction(
  'UPDATE_FHQ_INVITATION_SETTING_REQUEST',
  'UPDATE_FHQ_INVITATION_SETTING_SUCCESS',
  'UPDATE_FHQ_INVITATION_SETTING_FAILURE',
)
<FhqInvitation[], FhqInvitation[], Error>();
